import type { ReactNode } from 'react';

import styles from './Accounting.module.css';
import { fmtUSD } from './rollups';

/**
 * A money table cell: a bold amount over a muted sub-line. Always renders
 * something — a blank bucket shows `$0` over its sub-line — so every row
 * keeps the same height across the matrix tables.
 */
export function MoneyCell({ cost, sub }: { cost: number; sub: ReactNode }) {
  return (
    <>
      <span className={styles.cellAmount}>{fmtUSD(cost)}</span>
      <span className={styles.cellCount}>{sub}</span>
    </>
  );
}

/** "5 commits" / "1 commit". */
export function commitsSub(count: number): string {
  return `${count} commit${count === 1 ? '' : 's'}`;
}
